import { AxiosError, isAxiosError } from "axios";

export const ACCOUNT_DELETED_PATHNAME = "/profile/deleteaccount/deleted";

type AccountDeletedResponse = { code: string; detail?: string };

/**
 * The backend keeps returning `403 { code: "account_deleted" }` on every
 * endpoint once an account is deleted, while the login endpoint itself still
 * succeeds. Any API error carrying this code means the session belongs to a
 * deleted account and the user must be sent to ACCOUNT_DELETED_PATHNAME.
 */
export function isAccountDeletedError(
  error: unknown
): error is AxiosError<AccountDeletedResponse> {
  return (
    isAxiosError(error) &&
    error.response?.status === 403 &&
    (error.response.data as AccountDeletedResponse | undefined)?.code ===
      "account_deleted"
  );
}
